import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import api from "../api";
import { Eye, EyeOff } from "lucide-react"; // Ícones

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      await api
        .post("/user/login", { email, password })
        .then((res) => {
          localStorage.setItem("token", res.data.token);
          localStorage.setItem("email", res.data.email);
          localStorage.setItem("role", res.data.role);
          localStorage.setItem("name", res.data.name);
          localStorage.setItem("cpf", res.data.cpf);
          navigate("/analise");
        })
        .catch((error) => {
          if (error.res) {
            toast.error("Email ou senha inválidos");
          } else if (error.request) {
            toast.error("Erro de conexão com o servidor.");
          } else {
            toast.error("Erro desconhecido: " + error.message);
          }
        });
    } catch (error) {
      toast.error("Erro ao realizar login. Tente novamente mais tarde.");
      console.error("Erro ao fazer login:", error);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-image" />
      <div className="auth-card-container">
        <div className="auth-card">
          <input
            className="input"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <div className="input-password-container">
            <input
              className="input"
              type={showPassword ? "text" : "password"}
              placeholder="Senha"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <span
              className="eye-icon"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
            </span>
          </div>
          <button className="button button-azul" onClick={handleLogin}>
            Entrar
          </button>
          <p className="pointer" onClick={() => navigate("/register")}>
            Ainda não tem conta? Cadastre-se
          </p>
        </div>
      </div>
    </div>
  );
}
